import { IActionHandler } from "../interfaces/event-actions";
import { emitEventV2 } from "../util/url";
import { useSession } from "./session";

export const useExternalActionHandler = (): [typeof onAction] => {
  const [session] = useSession();
  const onAction: IActionHandler = (action, details) => {
    if (action.store === "EXTERNAL") {
      if (action.type === "EXTERNAL CLOSE") {
        emitEventV2("CLOSE", null);
      } else if (action.type === "EXTERNAL OPEN_DEEPLINK") {
        emitEventV2("OPEN_DEEPLINK", action.payload);
      } else if (action.type === "EXTERNAL SHARE") {
        emitEventV2("SHARE", action.payload);
      } else if (action.type === "EXTERNAL OPEN_WEB_LINK") {
        let link = action.payload.link;
        const platform = session?.queryParams?.platform;
        if(platform && action.payload[platform]) {
          link = action.payload[platform] as string;
        }
        if(action.payload.openInSameTab) {
          window.location.href = link;
        } else {
          open(link);
        }
      } else if(action.type === "EXTERNAL SHOW_LOADER"){
        emitEventV2("SHOW_LOADER",null);
      }else if(action.type === "EXTERNAL HIDE_LOADER"){
        emitEventV2("HIDE_LOADER",null);
      }else if(action.type === "EXTERNAL OPEN_CG_WEBVIEW"){
        emitEventV2("OPEN_CG_WEBVIEW", action.payload);
      } else if (action.type === "EXTERNAL JS_SDK_LOGIN") {
        const e: any = {
          target: "GLU_SDK",
          action: {
            type: "LOGIN",
            data: {
              url: action.payload?.url,
            },
          },
        };
        window.parent.postMessage(e, "*");
      }
      if (details && details.onComplete) {
        details.onComplete();
      }
    }
  };

  return [onAction];
};
